<h1 mat-dialog-title>Actividades</h1>
<div>
    <div class="observation-table-scroll">
        <mat-spinner *ngIf="loading"></mat-spinner>
        <table style="width:100%" *ngIf="!loading" class="table-content">
            <tr>
                <th class="cell-date">Fecha</th>
                <th>Acción</th>
                <th class="cell-date">Usuario</th>
            </tr>

            <tr *ngFor="let log of logs">
                <td style="min-width:140px; word-wrap: break-word" class="cell-date">{{ log.Date | date:'dd/MM/yyyy HH:mm' }}</td>
                <td>
                    <div style="width:100%; max-width: 400px; word-wrap: break-word">{{log.Description}} </div>
                </td>
                <td style="min-width:200px; word-wrap: break-word" class="cell-date">{{log.User}}</td>
            </tr>
        </table>
    </div>
</div>
<div class="clearfix">
    <div class="pull-right">
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
    </div>
</div>
